import test from "./src/test.vue"
import tableList from "./src/table.vue"
export default Vue => {
    Vue.component(test.name,test);
    Vue.component(tableList.name, tableList);
}